import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ConsultasService } from '@app/services/consultas.service';
import { RelatorioService } from '@app/services/relatorio.service';
import { UtilitarioService } from '@app/services/utilitario.service';
import { CDSMask } from '@app/utils/cds-mask';
import debounce from '@app/utils/debounce';
import { FiltrosReceberRecebidas } from '@app/pages/relatorios/receber-recebidas/filtros-receber-recebidas';
import { ContasReceber } from '@app/models/contas-receber';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-receber-recebidas',
  templateUrl: './receber-recebidas.component.html',
  styleUrls: ['./receber-recebidas.component.scss']
})
export class ReceberRecebidasComponent implements OnInit {

  cdsMask: CDSMask = new CDSMask();
  lstUnidades: IdDescricao[];
  lstParticipante: Array<any> = [{}];
  lstConta: IdDescricao[] = [];
  filtros: FiltrosReceberRecebidas = new FiltrosReceberRecebidas();

  checkReceber = true;
  checkRecebidas = false;
  checkTodas = false;

  relatorioRecebidas: ContasReceber[];
  relatorioReceber: ContasReceber[];
  relatorioReceberRecebidas: any[];

  nomeParticipanteRelatorio: string = "";

  totalReceber = 0;
  totalRecebidas = 0;
  pesquisando: boolean;

  dataRelatorio: Date;

  _debounce: any;
  _pesquisa: any;

  constructor(
    private relatorioService: RelatorioService,
    private consultasService: ConsultasService,
    @Inject(ToastrService) public toastr: ToastrService
  ) { }

  ngOnInit() {
    // this.filtros.UnidadeId = [];
    this.filtros.TipoData = 'Vencimento';
    this.consultasService.consultar('UNIDADE_S_RATEIO').toPromise().then(data => this.lstUnidades = data);
    this.consultasService.consultar('CONTA').toPromise().then(data => this.lstConta = data);
    this.pesquisando = false;
  }


  pesquisar() {
    this.dataRelatorio = new Date();
    this.relatorioReceber = [];
    this.relatorioRecebidas = [];
    this.relatorioReceberRecebidas = [];
    if (this.checkReceber === true) {
      this.PesquisarReceber();
    }
    if (this.checkRecebidas === true) {
      this.PesquisarRecebidas();
    }
    if (this.checkTodas === true) {
      this.PesquisarReceber()
        .then(() => this.PesquisarRecebidas()
          .then(() => {
            this.relatorioReceberRecebidas = [...this.relatorioReceber, ...this.relatorioRecebidas];
            this.SomaSaldoTodas();
            this.relatorioReceber = [];
            this.relatorioRecebidas = [];
          })
        );
    }
  }

  get sortData() {
    if (this.filtros.TipoData === 'Vencimento') {
      if (this.relatorioReceberRecebidas) {
        return this.relatorioReceberRecebidas.sort((a, b) => {
          return <any>new Date(a.DataVencimento) - <any>new Date(b.DataVencimento);
        }).filter(data => data.ReferenciaId == null);
      }
    } else {
      if (this.relatorioReceberRecebidas) {
        return this.relatorioReceberRecebidas.sort((a, b) => {
          return <any>new Date(a.DataEmissao) - <any>new Date(b.DataEmissao);
        }).filter(data => data.ReferenciaId == null);
      }
    }
  }

  async PesquisarReceber() {
    this.pesquisando = true;
    await this.relatorioService.receber(this.filtros)
      .toPromise().then((data) => {
        this.relatorioReceber = data;
        this.somaSaldo();
        this.pesquisando = false;

        if (this.relatorioReceber.length === 0) {
          this.toastr.info("Busca não encontrou resultados para 'recebidas'")
        }
      },
        () => {
          this.pesquisando = false
          this.toastr.warning("Realize a pesquisa novamente.")
        });
  }

  async PesquisarRecebidas() {
    this.pesquisando = true;
    await this.relatorioService.recebidas(this.filtros).toPromise().then((data) => {
      this.relatorioRecebidas = data;
      this.somaSaldo();
      this.pesquisando = false;

      if (this.relatorioRecebidas.length === 0) {
        this.toastr.info("Busca não encontrou resultados para 'recebidas'");
      }
    },
      () => {
        this.pesquisando = false
        this.toastr.warning("Realize a pesquisa novamente.")
      });
  }

  async controleCheckbox(parametro: 'RECEBER' | 'RECEBIDAS' | 'TODAS', evento: Event): Promise<void> {

    if (!(evento.target as HTMLInputElement).checked) {
      return;
    }

    this.checkReceber = (parametro === 'RECEBER');
    this.checkRecebidas = (parametro === 'RECEBIDAS');
    this.checkTodas = (parametro === 'TODAS');

    if (!this.checkRecebidas && this.filtros.TipoData === 'Recebimento') {
      this.filtros.TipoData = "Vencimento";
    }

    await this.pesquisar();
  }

  public somaSaldo(): void {
    if (this.checkRecebidas === true) {
      this.totalRecebidas = 0;
      this.relatorioRecebidas.forEach(element => { this.totalRecebidas += element.ValorRecebido; });
    }
    if (this.checkReceber === true) {
      this.totalReceber = 0;
      this.relatorioReceber.forEach(element => { this.totalReceber += element.Valor; });
    }
  }

  public SomaSaldoTodas(): void {
    this.totalRecebidas = 0;
    this.relatorioRecebidas.forEach(element => { this.totalRecebidas += element.ValorRecebido; });

    this.totalReceber = 0;
    this.relatorioReceber.forEach(element => { this.totalReceber += element.Valor; });
  }


  @ViewChild('relatorioRecebidasElement') relatorioRecebidasElement: ElementRef;
  public imprimirRelatorioRecebidas(): void {
    let conteudo = document.getElementById("relatorioRecebidas").innerHTML;
    UtilitarioService.imprimirHTML(conteudo, "Relatório Recebidas", this.montaImpressaoFiltros());
  }

  @ViewChild('relatorioReceberElement') relatorioReceberElement: ElementRef;
  public imprimirRelatorioReceber() {
    let conteudo = document.getElementById("relatorioReceber").innerHTML;
    UtilitarioService.imprimirHTML(conteudo, "Relatório Receber", this.montaImpressaoFiltros());
  }

  @ViewChild('relatorioReceberRecebidasElement') relatorioReceberRecebidasElement: ElementRef;
  public imprimirRelatorioReceberRecebidas() {
    let conteudo = document.getElementById("relatorioReceberRecebidas").innerHTML;
    UtilitarioService.imprimirHTML(conteudo, "Relatório Receber Recebidas", this.montaImpressaoFiltros());
  }

  private montaImpressaoFiltros(){
    let objetoFiltros = new Map<string, string>();
    
    adicionaMapValido('Emitido em', this.dataRelatorio.toLocaleString());
    adicionaMapValido('Cod. Processo', this.filtros.ProcessoId);

    parseDateAdicionaMap(this.filtros.TipoData, ' Inicial', this.filtros.DataInicial);
    parseDateAdicionaMap(this.filtros.TipoData, ' Final', this.filtros.DataFinal);

    adicionaMapValido('Participante', this.nomeParticipanteRelatorio);
    obtemDescricaoAdicionaMap('Unidade', this.lstUnidades, this.filtros.UnidadeId);
    obtemDescricaoAdicionaMap('Conta', this.lstConta, this.filtros.ContaId);

    if(this.checkRecebidas || this.checkTodas)
      adicionaMapValido("Total Recebidas", "R$ " + this.totalRecebidas.toLocaleString('pt-BR', { minimumFractionDigits: 2 }));

    if(this.checkReceber || this.checkTodas)
      adicionaMapValido("Total a Receber", "R$ " + this.totalReceber.toLocaleString('pt-BR', { minimumFractionDigits: 2 }));

    function obtemDescricaoAdicionaMap(chave: string, listaItens: IdDescricao[], idItem: number){
      if(idItem){
        let valor = listaItens.find(x => x.Id === idItem).Descricao;
        objetoFiltros.set(chave, valor);
      } 
    }

    function parseDateAdicionaMap(tipoData: string, inicialFinal: string, data: string){
      if(data && data.indexOf('-') >= 0){
        let dataPartes = data.split('-');
        let dataMontada = dataPartes[2] + '/' + dataPartes[1] + '/' + dataPartes[0];
        objetoFiltros.set(tipoData + inicialFinal, dataMontada);
      }
    }

    function adicionaMapValido(chave: string, valor: any){
      if(valor){
        objetoFiltros.set(chave, valor.toString());
      }
    }

    let stringHtml = '';

    objetoFiltros.forEach((valor, chave) => {
      stringHtml += `<tr><td>${chave}</td><td>${valor}</td></tr>`;
    })
    return stringHtml;
  }

  public possuiProcesso(item: ContasReceber) : boolean {
    return item.Processo && item.Processo !== '';
  } 

}
